import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';

import { HomeComponent } from './home/home.component';
import { HomeLivingPnwComponent } from './home-living-pnw/home-living-pnw.component';
import { MovingSeattleComponent } from './moving-seattle/moving-seattle.component';
import { ImportCivicComponent } from './import-civic/import-civic.component';
import { HomeEngineeringCodingComponent } from './home-engineering-coding/home-engineering-coding.component';
import { AdventOfCodeComponent } from './advent-of-code/advent-of-code.component';

import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';

@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        HomeLivingPnwComponent,
        MovingSeattleComponent,
        ImportCivicComponent,
        HomeEngineeringCodingComponent,
        AdventOfCodeComponent,
        PageNotFoundComponent,
        PrivacyPolicyComponent,
    ],
    imports: [BrowserModule, NgbModule.forRoot(), AppRoutingModule],
    providers: [],
    bootstrap: [AppComponent],
})
export class AppModule {}



// WEBPACK FOOTER //
// /Users/masonpimentel/Repos/mason-blog/src/app/app.module.ts